module.exports = __webpack_public_path__ + "img/PL08597.ec638b73.png";